import React, { useState, useEffect } from 'react';
import {
  MdDashboard,
  MdKeyboardArrowDown,
  MdPowerSettingsNew,
  MdFingerprint,
  MdPeopleOutline,
  MdHome,
  MdWork,
  MdAssessment,
  MdSettings,
  MdEmail,
  MdBuild,
  MdPerson,
} from 'react-icons/md';
import { RiAdminFill } from 'react-icons/ri';
import { IoMedicalSharp } from 'react-icons/io5';
import { NavLink } from 'react-router-dom';
import {
  Collapse,
  Nav,
  Navbar,
  NavItem,
  NavLink as BSNavLink,
} from 'reactstrap';
import { useSelector, useDispatch } from 'react-redux';
import { call } from '../../redux/services/api';

import SourceLink from '../SourceLink';
import bn from '../../utils/bemnames';
import isThisDisabled from '../../utils/isThisDisabled';
import { logout } from '../../redux/actions';
import { entries } from '../../data/pollEntries';

const elections2021Executives = [
  {
    to: '/elections/hall-chairperson',
    name: 'Hall Chairperson',
    exact: false,
    Icon: MdWork,
  },
  {
    to: '/elections/deputy-hall-chairperson',
    name: 'Deputy Hall Chairperson',
    exact: false,
    Icon: MdWork,
  },
  {
    to: '/elections/hall-secretary',
    name: 'Hall Secretary',
    exact: false,
    Icon: MdWork,
  },
  {
    to: '/elections/finance-minister',
    name: 'Finance Minister',
    exact: false,
    Icon: MdWork,
  },
  {
    to: '/elections/information-minister',
    name: 'Information Minister',
    exact: false,
    Icon: MdWork,
  },
  {
    to: '/elections/health-minister',
    name: 'Health/Sanitation Minister',
    exact: false,
    Icon: MdWork,
  },
  {
    to: '/elections/social-minister',
    name: 'Social/Buttery Minister',
    exact: false,
    Icon: MdWork,
  },
  {
    to: '/elections/sports-minister',
    name: 'Sports Minister',
    exact: false,
    Icon: MdWork,
  },
  {
    to: '/elections/defence-minister',
    name: 'Defence Minister',
    exact: false,
    Icon: MdWork,
  },
  {
    to: '/elections/fa-minister',
    name: 'Female Affairs Minister',
    exact: false,
    Icon: MdWork,
  },
];
const elections2021HallAssembly = [
  {
    to: '/elections/floor-reps',
    name: 'Floor Reps',
    exact: false,
    Icon: MdWork,
  },
];
const elections2021Results = [
  {
    to: '/results/executives',
    name: 'Executives',
    exact: false,
    Icon: MdPeopleOutline,
  },
  {
    to: '/results/hall-assembly',
    name: 'Hall Assembly',
    exact: false,
    Icon: MdHome,
  },
];
const adminPanel = [
  {
    to: '/admin',
    name: 'Dashboard',
    exact: true,
    Icon: MdDashboard,
  },
  {
    to: '/admin/settings',
    name: 'Election Settings',
    exact: false,
    Icon: MdSettings,
  },
  {
    to: '/admin/candidates',
    name: 'Candidates',
    exact: false,
    Icon: MdPerson,
  },
  {
    to: '/admin/email',
    name: 'Email Center',
    exact: false,
    Icon: MdEmail,
  },
  {
    to: '/admin/controls',
    name: 'System Controls',
    exact: false,
    Icon: MdBuild,
  },
  {
    to: '/admin/users',
    name: 'User Management',
    exact: false,
    Icon: IoMedicalSharp,
  },
];



const navItems1 = [
  { to: '/dashboard', name: 'Dashboard', exact: true, Icon: MdDashboard },
  { to: '/account', name: 'Account', exact: false, Icon: MdSettings },
];
const navItems2 = [
  {
    to: '/login',
    name: 'Logout',
    exact: true,
    Icon: MdPowerSettingsNew,
    onClick: logout,
  },
];
const isDisabledStyle = {
  color: 'grey',
  cursor: 'not-allowed',
  opacity: 0.5,
  textDecoration: 'none',
};

const bem = bn.create('sidebar');
const SideBar = () => {
  const dispatch = useDispatch();
  const user = useSelector(state => state.auth.user);
  const [activeSettings, setActiveSettings] = useState(null);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const { data } = await call('get', 'settings/public');
        setActiveSettings(data);
      } catch (err) {
        console.error('Error fetching settings', err);
      }
    };
    fetchSettings();
  }, []);

  const now = new Date();

  // Results Visibility Logic
  const isResultsTime =
    activeSettings?.resultsStart &&
    activeSettings?.resultsEnd &&
    now >= new Date(activeSettings.resultsStart) &&
    now <= new Date(activeSettings.resultsEnd);

  const canViewResults =
    user.role === 'ADMIN' ||
    user.role === 'SUPER_ADMIN' ||
    (activeSettings?.isResultsVisible && isResultsTime);

  // Voting Visibility Logic
  // Parsing Dates safely
  const votingStart = activeSettings?.votingStart ? new Date(activeSettings.votingStart) : null;
  const votingEnd = activeSettings?.votingEnd ? new Date(activeSettings.votingEnd) : null;

  const isVotingTime =
    votingStart &&
    votingEnd &&
    now >= votingStart &&
    now <= votingEnd;

  const canVote =
    user.role === 'ADMIN' ||
    user.role === 'SUPER_ADMIN' ||
    isVotingTime; // Purely Date Based now (User Request)

  const {
    isDisabledElections,
    isDisabledElectionsExecutive,
    isDisabledElectionsHallAssembly,
    isDisabledElectionResults,
  } = isThisDisabled(user);
  const [state, setState] = useState({
    isOpen2021Elections: !isDisabledElections,
    isOpen2021ElectionsExecutive: !isDisabledElectionsExecutive,
    isOpen2021ElectionsHallAssembly: !isDisabledElectionsHallAssembly,
    isOpen2021ElectionsResults: !isDisabledElectionResults,
    isOpenAdminPanel: true,
    isOpenUserManagement: false,
  });
  const handleClick = name => () => {
    setState(prevState => {
      const isOpen = prevState[`isOpen${name}`];

      return {
        ...prevState,
        [`isOpen${name}`]: !isOpen,
      };
    });
  };
  const toggleClose = () => {
    document.querySelector('.cr-sidebar').classList.toggle('cr-sidebar--open');
  };
  return (
    <aside className={bem.b()}>
      <div className={bem.e('background')} />
      <div className={bem.e('content')}>
        <Navbar>
          <SourceLink className="navbar-brand d-flex">
            <img
              src="https://res.cloudinary.com/dcjxlbq4z/image/upload/v1612836816/abhelections/ABH_Logo_mel2e1.jpg"
              width="40"
              height="30"
              className="pr-2"
              alt=""
            />
            <span className="text-white">ABH eVoting</span>
          </SourceLink>
        </Navbar>
        <Nav vertical>
          {navItems1.map(({ to, name, exact, Icon }, index) => (
            <NavItem key={index} className={bem.e('nav-item')}>
              <BSNavLink
                id={`navItem-${name}-${index}`}
                className=""
                tag={NavLink}
                to={to}
                onClick={toggleClose}
                activeClassName="active"
                exact={exact}
              >
                <Icon className={bem.e('nav-item-icon')} />
                <span className="">{name}</span>
              </BSNavLink>
            </NavItem>
          ))}
          {/* 2021 elections */}
          {/* 2026 elections */}
          {canVote && (
            <NavItem className={bem.e('nav-item')}>
              <BSNavLink
                className=""
                tag={NavLink}
                to="/elections/executives"
                onClick={toggleClose}
              >
                <MdFingerprint className={bem.e('nav-item-icon')} />
                <span className="">2026 Elections</span>
              </BSNavLink>
            </NavItem>
          )}

          {/* Election Results */}
          {/* Election Results */}
          {/* Election Results - Visible only to Super Admin */}
          {/* Election Results - Visible if active or Admin */}
          {canViewResults && (
            <NavItem className={bem.e('nav-item')}>
              <BSNavLink
                className=""
                tag={NavLink}
                to="/results"
                onClick={toggleClose}
              >
                <MdAssessment className={bem.e('nav-item-icon')} />
                <span className="">Election Results</span>
              </BSNavLink>
            </NavItem>
          )}

          {/* Admin Panel */}
          {(user.role === 'ADMIN' || user.role === 'SUPER_ADMIN') && (
            <>
              <NavItem
                className={bem.e('nav-item')}
                onClick={handleClick('AdminPanel')}
              >
                <BSNavLink className={bem.e('nav-item-collapse')}>
                  <div className="d-flex">
                    <RiAdminFill className={bem.e('nav-item-icon')} />
                    <span className=" align-self-start">Admin Panel</span>
                  </div>
                  <MdKeyboardArrowDown
                    className={bem.e('nav-item-icon')}
                    style={{
                      padding: 0,
                      transform: state.isOpenAdminPanel
                        ? 'rotate(0deg)'
                        : 'rotate(-90deg)',
                      transitionDuration: '0.3s',
                      transitionProperty: 'transform',
                    }}
                  />
                </BSNavLink>
              </NavItem>
              <Collapse
                isOpen={state.isOpenAdminPanel}
                style={{ marginLeft: 10 }}
              >
                {adminPanel.map(({ to, name, exact, Icon }, index) => (
                  <NavItem key={index} className={bem.e('nav-item')}>
                    <BSNavLink
                      id={`navItem-${name}-${index}`}
                      className=""
                      tag={NavLink}
                      to={to}
                      onClick={toggleClose}
                      activeClassName="active"
                      exact={exact}
                    >
                      <Icon className={bem.e('nav-item-icon')} />
                      <span className="">{name}</span>
                    </BSNavLink>
                  </NavItem>
                ))}

              </Collapse>
            </>
          )}

          {navItems2.map(({ to, name, exact, Icon, onClick }, index) => (
            <NavItem key={index} className={bem.e('nav-item')}>
              <BSNavLink
                id={`navItem-${name}-${index}`}
                className=""
                tag={NavLink}
                to={to}
                activeClassName="active"
                exact={exact}
                onClick={() => dispatch(onClick())}
              >
                <Icon className={bem.e('nav-item-icon')} />
                <span className="">{name}</span>
              </BSNavLink>
            </NavItem>
          ))}
        </Nav>
      </div>
    </aside>
  );
};

export default SideBar;
